const trailingZeroRegex = /\.00$/;

/**
 * @typedef {"EUR"|"PLN"|"SEK"} Currency
 */

/**
 * @param {Currency} currency
 * @param {Number} price
 * @returns {string}
 */
export function formatPrice(currency, price) {
  price = Number(price);

  const symbol = currencySymbol(currency);
  const formattedPrice = formatPriceWithoutSign(currency, price);

  switch (currency) {
    case "PLN":
    case "SEK":
      return `${formattedPrice} ${symbol}`;
    case "EUR":
    default:
      return `${symbol} ${formattedPrice}`;
  }
}

/**
 * @param {Currency} currency
 * @param {Number} price
 * @returns {string}
 */
export function formatPriceWithoutSign(currency, price) {
  price = Number(price);

  switch (currency) {
    case "PLN":
      return `${price.toFixed(2).replace(trailingZeroRegex, "")}`;
    case "EUR":
    case "SEK":
    default:
      return `${price.toFixed(2)}`;
  }
}

/**
 * @param {Currency} currency
 * @returns {string}
 */
export function currencySymbol(currency) {
  switch (currency) {
    case "PLN":
      return "zł";
    case "EUR":
      return "€";
    case "SEK":
      return "kr";
  }
}
